// extracted by mini-css-extract-plugin
export default {"commonPagination":"CommonPagination_commonPagination__ZWHxa"};